module.exports = __webpack_public_path__ + "img/Scanvaegt6.d82ab53f.png";